import { useState } from 'react';

/**
 * A key that changes each time `open` turns true, and each time `subject`
 * changes while it is.
 *
 * A dialog's form state belongs to one opening of it. Keying the form by this
 * starts that state afresh when the dialog opens, from its initial values,
 * where an effect resetting each field would render the stale ones first.
 */
export function useOpeningKey<T>(open: boolean, subject?: T): number {
  const [seen, setSeen] = useState({ open, subject, key: 0 });
  if (seen.open === open && seen.subject === subject) {
    return seen.key;
  }
  const key = open ? seen.key + 1 : seen.key;
  setSeen({ open, subject, key });
  return key;
}
